/**
 * Report types selectable on the project Reports sub-tab.
 *
 * Declared in its own leaf module (rather than on the page component) so that
 * sibling components can import it without creating a circular dependency back
 * through the page. The values are user-facing labels and are also persisted to
 * `localStorage` under `selectedReportTypes-${projectId}`.
 */
export enum ReportTypes {
    Submittals = 'Submittals',
    UnresolvedOptions = 'Unresolved Options',
}
